import {
  showErrorNotification,
  showSuccessNotification,
  showInfoNotification,
} from '@/util/notifications'
export default {
  methods: {
    errorNotification(message = 'Ocurrió un error', duration = 1500) {
      showErrorNotification(this, message)
    },
    successNotification(message, duration = 1500) {
      showSuccessNotification(this, message, duration)
    },
    infoNotification(message, duration = 10000) {
      showInfoNotification(this, message, duration)
    },
  },
}
